<template>
  <div class="align-items-center justify-content-center activityPopup">
    <div class="popup-container">
      <transition name="bounce">
        <div v-show="open" class="popup-content box" :class="[name]">
          <div v-if="rewardsList.length > 0" class="info-window">
            <div class="header"></div>

            <div v-if="rewardsList[rewardIndex]?.type === 'points'" class="info-content">
              <div class="point-icons">
                <div :key="i" v-for="i in rewardsList[rewardIndex]?.value" class="icon"
                     :class="rewardsList[rewardIndex]?.type"></div>
              </div>
              <p class="title">{{ rewardsList[rewardIndex]?.value }}X ENERGIE VERDIEND</p>
              <p class="description">{{
                  getTextForRewardType(rewardsList[rewardIndex]?.type,
                      rewardsList[rewardIndex]?.value)
                }}</p>
            </div>

            <div v-if="rewardsList[rewardIndex]?.type === 'level'" class="info-content">
              <div class="icon" :class="rewardsList[rewardIndex]?.type"></div>
              <p class="title">LEVEL {{ rewardsList[rewardIndex]?.value }}</p>
              <p class="description">{{
                  getTextForRewardType(rewardsList[rewardIndex]?.type,
                      rewardsList[rewardIndex]?.value)
                }}</p>
            </div>

            <div v-if="rewardsList[rewardIndex]?.type === 'color'" class="info-content">
              <div class="icon" :class="rewardsList[rewardIndex].type"></div>
              <p class="title">MOOI KLEURTJE!</p>
              <p class="description">{{ getTextForRewardType(rewardsList[rewardIndex]?.type) }}</p>
            </div>

            <div v-if="rewardsList[rewardIndex]?.type === 'animation'" class="info-content">
              <div class="icon" :class="rewardsList[rewardIndex].type"></div>
              <p class="title">LEVENDIG</p>
              <p class="description">{{ getTextForRewardType(rewardsList[rewardIndex]?.type) }}</p>
            </div>

            <div v-if="rewardsList[rewardIndex]?.type === 'posture'" class="info-content">
              <div class="icon" :class="rewardsList[rewardIndex].type"></div>
              <p class="title">POSTUUR</p>
              <p class="description">{{ getTextForRewardType(rewardsList[rewardIndex]?.type) }}</p>
            </div>

            <div v-if="rewardsList[rewardIndex]?.type === 'accessory'" class="info-content">
              <div class="icon" :class="rewardsList[rewardIndex].type"></div>
              <div class="icon thumbnail" v-html="rewardsList[rewardIndex].svg.svg.outerHTML"></div>
              <p class="title">NIEUW ACCESSOIRE</p>
              <p class="description">{{ getTextForRewardType(rewardsList[rewardIndex]?.type) }}</p>
            </div>

            <div class="footer"></div>

            <div class="button-row">
              <WhiteOutlineButton :buttonText="'VOLGENDE'" :stretch-to-fill="true"
                                  v-on:clicked="nextClicked"></WhiteOutlineButton>

              <WhiteOutlineButton v-if="rewardsList[rewardIndex]?.type === 'accessory'" :buttonText="'GADGET PASSEN'"
                                  :stretch-to-fill="true"
                                  v-on:clicked="tryOnGadgetClicked"></WhiteOutlineButton>
            </div>

          </div>

        </div>
      </transition>

    </div>
  </div>


</template>

<script>
import log from "@/utils/logger";

import ThumbnailLibrary from "@/mixins/ThumbnailLibrary";
import WhiteOutlineButton from "@/components/StudentPlatform/WhiteOutlineButton";
import SoundPlayer from "@/utils/SoundPlayer";
import {Sound} from "@/enums/Sound";
//import SoundPlayer from "@/utils/SoundPlayer";
//import {Sound} from "@/enums/Sound";

export default {
  name: "RewardPopup",
  components: { WhiteOutlineButton },
  mixins: [ ThumbnailLibrary ],
  props: {
    name: String,
    open: Boolean,
    levelUpReward: Object,
    buddyData: Object
  },
  watch: {
    open: {
      handler()
      {
        if (this.open)
        {
          log.info("opening");
        }
        else
        {
          log.info("closing");
        }
      },
      deep: true,
    },
    levelUpReward: {
      handler()
      {
        if (this.levelUpReward !== null)
        {
          this.setUpRewards();
        }
      },
      deep: true,
    }
  },
  data()
  {
    return {
      show: this.open,
      rewardIndex: 0,
      rewardsList: [],
      rewardTexts: {
        points: [
          "Knap werk! jullie hebben [value] batterijtje[addS] behaald, doe zo verder!",
          "Super straf, jullie hebben [value] batterijtje[addS] verdiend. Op naar de volgende!",
          "Cool, jullie hebben [value] batterijtje[addS] verdiend. Ga naar de volgende opdracht om nog wat extra energie te sprokkelen.",
          "Goed gedaan, [value] extra batterijtje[addS] erbij. Doe zo verder!",
          "Proficiat klas, jullie hebben [value] batterijtje[addS] verdiend. Doe zo verder!",
          "Wat een teamwerk, jullie hebben [value] batterijtje[addS] verdiend. Proficiat en doe zo verder!",
        ],
        level: [
          "Wauw! Je buddy is een level gestegen!"
        ],
        color: [
          "De vacht van je beweegbuddy ziet er frisser en gezonder uit"
        ],
        posture: [
          "Je beweegbuddy ziet er minder futloos en gelukkiger uit."
        ],
        animation: [
          "Je beweegbuddy ziet er energieker uit."
        ],
        accessory: [
          "Waaaaaw! Een nieuw gadget om je beweegbuddy hipper te maken is beschikbaar.",
          "Super cool! Je beweegbuddy kan een nieuw gadget passen.",
          "Zo tof, er is een nieuw gadget beschikbaar voor je beweegbuddy.",
          "Fantastisch! Een nieuw gadget om je beweegbuddy hipper te maken is beschikbaar.",
          "Oooooh zo leuk! Je beweegbuddy kan een nieuw gadget passen.",
          "Super tof, er is een nieuw gadget beschikbaar voor je beweegbuddy.",
          "Woehoeeew! Een nieuw gadget is beschikbaar om je beweegbuddy nog cooler kan maken.",
        ],

      }
    }
  },
  computed: {},
  methods: {

    setUpRewards()
    {
      this.rewardsList = [];

      if (this.levelUpReward.points > 0)
      {
        this.rewardsList.push({ type: "points", value: this.levelUpReward.points });
      }

      if (this.levelUpReward.level)
      {
        this.rewardsList.push({ type: "level", value: this.levelUpReward.level });
      }

      if (this.levelUpReward.animationImproved)
      {
        this.rewardsList.push({ type: "animation" });
      }

      if (this.levelUpReward.colorVibrancyImproved)
      {
        this.rewardsList.push({ type: "color" });
      }

      if (this.levelUpReward.postureImproved)
      {
        this.rewardsList.push({ type: "posture" });
      }

      if (this.levelUpReward.accessoryRewards)
      {
        this.levelUpReward.accessoryRewards.forEach(accRew =>
        {
          ThumbnailLibrary.getThumbFromFile(accRew.name, this.buddyData.buddyConfig.grade).then((svg) =>
          {
            log.info(svg);
            this.rewardsList.push({ type: "accessory", data: accRew, svg: svg });
          });

        });
      }


      log.info(this.rewardsList);
    },

    getTextForRewardType(type, value)
    {
      log.info(type);
      log.info(value);
      let stringArray = this.rewardTexts[type];
      let text = stringArray[Math.floor(Math.random() * stringArray.length)];
      if (value)
      {
        text = text.replace('[value]', value);
        if (value > 1)
        {
          text = text.replace('[addS]', 's');
        }
        else
        {
          text = text.replace('[addS]', '');

        }
      }
      return text;
    },


    nextClicked()
    {
      if (this.rewardIndex < this.rewardsList.length - 1)
      {
        this.rewardIndex++;
      }
      else
      {
        this.$emit("closeClicked");
        this.rewardIndex = 0;
      }

      if (this.rewardsList[this.rewardIndex]?.type === 'level') {
        SoundPlayer.playSound(Sound.LEVELUP);
      }

      if (this.rewardsList[this.rewardIndex]?.type === 'accessory') {
        SoundPlayer.playSound(Sound.LEVELUP);
      }
    },

    tryOnGadgetClicked()
    {
      if (this.rewardIndex >= this.rewardsList.length - 1)
      {
        this.rewardIndex = 0;
        this.$emit("tryOnGadgetClicked");
      }
    }


  },
  mounted()
  {

    //TODO: get activities every couple of minutes


  },
  created()
  {
  },
}


</script>

<style lang="scss" scoped>

.activityPopup {
  width: 100vw;
  height: 100vh;
  position: absolute;
  background-color: rgba(0, 0, 0, 0);
  z-index: 9999;
  top: 0;
  left: 0;
  display: flex;

  .popup-container {
    width: 49vw;
    margin-left: 49vw;
    //width: min(70vw, 70vh);
    height: min(70vw, 70vh);
  }

}

.popup-content {
  //margin-bottom: 10px;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  //height: 98%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9%;
  position: relative;
}

.info-window {
  width: 100%;
  position: relative;

  .header {
    background-image: url("~@/assets/image/platform/frame/frame_medium_top.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: bottom center;
    height: min(5vw, 11vh);
    top: 1px;
    position: relative;
  }

  .info-content {
    background-image: url("~@/assets/image/platform/frame/frame_medium_mid.svg");
    background-size: 100%;
    background-position: center center;
    position: relative;
    padding: 25px 50px;

  }

  .footer {
    background-image: url("~@/assets/image/platform/frame/frame_medium_bot.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: top center;
    height: min(5vw, 11vh);
  }

}

.title {
  font-size: 2rem;
  font-weight: bold;
  color: white;
  text-align: center;
}

.description {
  color: white;
  font-size: 1.3rem;
}

.icon {
  width: 100%;
  position: relative;
  top: -115px;
  margin-bottom: -100px;
  background-position: center;
  background-repeat: no-repeat;
  height: 100px;
  background-image: $impulse-icon-outline;
  background-size: contain;

  &.thumbnail {
    background-image: none;
    display: flex;
    justify-content: center;

    svg {
      height: 100%;
    }
  }

  &.points {
    background-image: $energy-icon-full;
    top: 0;
    height: 50px;
    margin-bottom: 20px;

  }

  &.thumbnail {
    margin-bottom: -75px;
    margin-top: 115px;
  }

}

.point-icons {
  display: flex;
  width: 50%;
  margin: 0 auto;

}

.level {
  background-image: $level-up-icon;
}

.posture {
  background-image: $posture-icon;
}

.animation {
  background-image: $vitality-icon;
}

.accessory {
  background-image: $accessory-icon;
}

.color {
  background-image: $color-icon;
}

.first {
  margin-bottom: 15px;
}

.bounce-enter-active {
  animation: bounce-in .5s;
}

.bounce-leave-active {
  animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.button-row {
  height: 15%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

</style>